import { Directive, Output, EventEmitter, HostListener, ElementRef } from '@angular/core';
import { Router } from '@angular/router';

declare var $:any;

@Directive({
  selector: '[appClickOutside]'
})
export class ClickOutsideDirective {

  constructor(private _elementRef : ElementRef, private router: Router) {
    }
 
    @Output() public clickOutside = new EventEmitter();
 
    
  @HostListener('document:click', ['$event.target'])
  public onClick(targetElement) {
    const isClickedInside = this._elementRef.nativeElement.contains(targetElement);
    if(!$(targetElement).closest('.modal-content').length){
        $('#thankyou_modal').modal('hide');
        //this.router.navigate(['/feed'])
        window.location.href = '/feed';
    }
    if (isClickedInside) {
        //this.router.navigate(['feed'])
    }else{
        $('#thankyou_modal').modal('hide');
        //this.router.navigate(['/feed'])
        window.location.href = '/feed';
    }
  }

}
